import React from 'react';

const FilterSegmentLibraryPage = ()=> {
    return<div>hi from Filter Segment Library</div>

} 
export default FilterSegmentLibraryPage;